module.exports = __webpack_public_path__ + "img/BC4.91522d44.svg";